import DataSourceModel from '../DataSourceModel';
import { simpleData } from '../ECharts/simpleData';
import { getDefaultProps } from '../TextableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends DataSourceModel {

    fontFamilyHeader = new PropertyDescriptor("", '字体', "表头", "font", "#anticon-font", {
        gallery: "外观",
        placeholder: '留空为默认字体或输入字体名称'
    })
    fontSizeHeader = new PropertyDescriptor(15, '字号', "表头", "double", "#anticon-font_size", {
        minValue: 0,
        catalogIndex: 20,
    })
    fontColorHeader = new PropertyDescriptor('#333', '颜色', "表头", "color", "#anticon-icon_Fontcolor")
    isBoldHeader = new PropertyDescriptor(true, '粗体', "表头", "bool", "#anticon-bold")
    paddingHHeader = new PropertyDescriptor(10, '水平间隔', "表头", "double", "#anticon-fit-width");
    paddingVHeader = new PropertyDescriptor(5, '垂直间隔', "表头", "double", "#anticon-fit-height");
    backgroundColorHeader = new PropertyDescriptor('transparent', '背景颜色', "表头", "color", "#anticon-backgroundred");

    fontFamilyBody = new PropertyDescriptor("", '字体', "内容", "font", "#anticon-font", {
        gallery: "外观",
        placeholder: '留空为默认字体或输入字体名称'
    })
    fontSizeBody = new PropertyDescriptor(15, '字号', "内容", "double", "#anticon-font_size", {
        minValue: 0,
        catalogIndex: 20,
    })
    fontColorBody = new PropertyDescriptor('#333', '颜色', "内容", "color", "#anticon-icon_Fontcolor")
    isBoldBody = new PropertyDescriptor(false, '粗体', "内容", "bool", "#anticon-bold")

    paddingHBody = new PropertyDescriptor(10, '水平间隔', "内容", "double", "#anticon-fit-width");
    paddingVBody = new PropertyDescriptor(5, '垂直间隔', "内容", "double", "#anticon-fit-height");
    backgroundColorBody1 = new PropertyDescriptor('transparent', '背景颜色 1', "内容", "color", "#anticon-backgroundred");
    backgroundColorBody2 = new PropertyDescriptor('transparent', '背景颜色 2', "内容", "color", "#anticon-backgroundred");


    borderWidthTable = new PropertyDescriptor(1, '边框宽度', "表格", "double", "#anticon-visualization-border", {
        gallery: "外观",
    });
    borderStyleTable = new PropertyDescriptor('solid', '边框风格', "表格", "enum", "#anticon-border-top", {
        values: [
            new PropertyDescriptor("solid", undefined, "边框风格", "string"),
            new PropertyDescriptor("dashed", undefined, "边框风格", "string"),
            new PropertyDescriptor("dotted", undefined, "边框风格", "string"),
            new PropertyDescriptor("double", undefined, "边框风格", "string"),
            new PropertyDescriptor("groove", undefined, "边框风格", "string"),
            new PropertyDescriptor("inset", undefined, "边框风格", "string"),
            new PropertyDescriptor("outset", undefined, "边框风格", "string"),
            new PropertyDescriptor("ridge", undefined, "边框风格", "string"),
            new PropertyDescriptor("hidden", undefined, "边框风格", "string"),
            new PropertyDescriptor("none", undefined, "边框风格", "string"),
            new PropertyDescriptor("unset", undefined, "边框风格", "string"),
        ]
    });
    borderColorTable = new PropertyDescriptor('#666', '边框颜色', "表格", "color", "#anticon-edit3");


    columns = new PropertyDescriptor(
        [
            {
                name: "星期",
                expression: "day",
            },
            {
                name: "迟到人数",
                expression: "lateCount",
            },
            {
                name: "忘写日志人数",
                expression: "forgetDailyCount",
            }
        ],
        '列', "表格", "tableColumns", "#anticon-lie", {
        catalogIndex: 10,
    });


    constructor(opts = {}) {
        super();

        this.defineAllProperties();

        this.setVisible();
        this.backgroundColor = "transparent";
        this.borderWidth = 0;

        this.width = 400;
        this.height = 200;

        this.dataValue = JSON.stringify(simpleData, null, 2);

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "DataTableModel";
    }

    toStyle() {

        return {
            ...super.toStyle(),
            // fontFamily: this.fontFamily,
            // fontSize: this.fontSize,
            // fontWeight: this.isBold ? 'bold' : 'normal',
            // color: this.fontColor,
            display: 'flex',
            flexDirection: 'row',
            alignItems: "flex-start",
            justifyContent: "flex-start",
            ...super.getExtendStyle(),
        }
    }
}
